import React, { Component } from 'react';
import { Button, ButtonToolbar, Table, Row, Modal, ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { SortIndicator } from '../../../SortIndicator';

import ColumnResize from "react-table-column-resizer";

export class MapPointStops extends Component {
    static contextTypes = {
        selectApp: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            isLoadingStops: true,
            isLoadingSelectedStops: true,
            selectedStops: [],
            stopsToRender: [],
            distance: props.distance || 0,
            sortOrderSelected: "ascending",
            sortOrderAvailable: "ascending",
            sortColumnSelected: "distance",
            sortColumnAvailable: "distance"
        };
        this.lastCoordinates = {
            latitude: props.mapPoint.latitude,
            longitude: props.mapPoint.longitude
        };
    }

    componentDidMount() {
        const selectedStops = this.addDistancesToStops(this.props.mapPoint.stops || []);
        const stopsToRender = this.addDistancesToStops(this.props.stops || []);

        this.setState({
            selectedStops,
            stopsToRender,
            isLoadingStops: false,
            isLoadingSelectedStops: false
        });
    }

    componentDidUpdate(prevProps) {
        const { mapPoint, stops } = this.props;
        const { selectedStops } = this.state;

        const coordsChanged = this.lastCoordinates.latitude !== mapPoint.latitude || this.lastCoordinates.longitude !== mapPoint.longitude;
        const stopsChanged = prevProps.stops !== stops;
        const mapPointStopsChanged = prevProps.mapPoint.stops !== mapPoint.stops;

        if (coordsChanged || stopsChanged || mapPointStopsChanged) {
            this.lastCoordinates = {
                latitude: mapPoint.latitude,
                longitude: mapPoint.longitude
            };

            const selectedStopsWithDistances = this.addDistancesToStops(selectedStops);
            const stopsToRenderWithDistances = this.addDistancesToStops(stops || []);

            this.setState({
                selectedStops: selectedStopsWithDistances,
                stopsToRender: stopsToRenderWithDistances,
                isLoadingStops: false,
                isLoadingSelectedStops: false
            });
        }
    }

    onHide() {
        const selectedStops = this.addDistancesToStops(this.props.mapPoint.stops || []);
        this.setState({ selectedStops }, () => {
            this.props.onHide();
        });
    }

    onSaveStopValue(selectedStops) {
        const selectedStopsWithDistances = this.addDistancesToStops(selectedStops || []);
        this.setState({ selectedStops: selectedStopsWithDistances }, () => {
            this.props.onSaveStopValue(selectedStops);
        });
    }

    onRemoveSelectedStopValue(stopId) {
        const { selectedStops, stopsToRender } = this.state;

        const updatedSelectedStops = selectedStops.filter(stop => stop.id !== stopId);
        const removedStop = selectedStops.find(stop => stop.id === stopId);
        let updatedStopsToRender = stopsToRender;

        if (removedStop && !stopsToRender.some(stop => stop.id === stopId)) {
            updatedStopsToRender = [...stopsToRender, removedStop];
        }

        this.setState({
            selectedStops: updatedSelectedStops,
            stopsToRender: updatedStopsToRender
        });
    }

    onChangeStopValue(stop) {
        const { selectedStops } = this.state;

        if (selectedStops.some(s => s.id === stop.id)) {
            return;
        }

        this.setState({ 
            selectedStops: [...selectedStops, stop]
        });
    }

    onCalculateCoordinates() {
        const { mapPoint } = this.props;
        const { selectedStops } = this.state;

        if(selectedStops.length === 0) {
            return;
        }

        this.setState({
            isLoadingStops: true,
            isLoadingSelectedStops: true
        });

        const allStops = [...(mapPoint.stops || []), ...(selectedStops || [])];
        const coordinates = allStops.reduce((output, stop) => {
            output.latitude += stop.latitude;
            output.longitude += stop.longitude;
            return output;
        }, { latitude: 0, longitude: 0 });

        mapPoint.latitude = coordinates.latitude / allStops.length;
        mapPoint.longitude = coordinates.longitude / allStops.length;

        this.setState({
            isLoadingStops: false,
            isLoadingSelectedStops: false
        });
    }

    onChangeSort = (tableName, column) => {
        const sortOrderKey = tableName === "Selecionados" ? "sortOrderSelected" : "sortOrderAvailable";
        const sortColumnKey = tableName === "Selecionados" ? "sortColumnSelected" : "sortColumnAvailable";

        const { [sortColumnKey]: sortColumn, [sortOrderKey]: sortOrder } = this.state;

        if (sortColumn === column) {
            this.setState({
                [sortOrderKey]: sortOrder === "ascending" ? "descending" : "ascending"
            });
        } else {
            this.setState({
                [sortColumnKey]: column,
                [sortOrderKey]: "ascending"
            });
        }
    };


    handleDistanceChange(e) {
        const value = e.target.value;

        this.setState({ 
            distance: value
        });


        if (this.props.onChangeValue) {
            this.props.onChangeValue(e, "distance");
        }
    }

    selectNearbyStops() {
        const { stopsToRender, selectedStops, distance } = this.state;

        const maxDistance = Number(distance);

        if (isNaN(maxDistance) || maxDistance <= 0) {
            return;
        } 

        const nearbyStops = stopsToRender.filter(
            stop => typeof stop.distance === 'number' && stop.distance <= maxDistance && !selectedStops.some(sel => sel.id === stop.id)
        );

        if (nearbyStops.length === 0) {
            return;
        } 
            
        this.setState({
            selectedStops: [...selectedStops, ...nearbyStops]
        });
    }

    addDistancesToStops(stops) {
        if (!Array.isArray(stops)) {
            return [];
        } 

        return stops.map(stop => ({...stop, distance: this.calculateStopDistance(stop)}));
    }

    calculateStopDistance(stop) {
        const { mapPoint } = this.props;
        if (!stop || !mapPoint) {
            return 0;
        } 

        const { latitude: pointLat, longitude: pointLng } = mapPoint;
        const { latitude: stopLat, longitude: stopLng } = stop;

        if ([pointLat, pointLng, stopLat, stopLng].some(val => typeof val !== 'number')) {
            return 0;
        }

        const R = 6371e3;
        const dLat = (stopLat - pointLat) * Math.PI / 180;
        const dLng = (stopLng - pointLng) * Math.PI / 180;
        const a = Math.sin(dLat / 2) ** 2 + Math.cos(pointLat * Math.PI / 180) * Math.cos(stopLat * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return Math.round(R * c);
    }

    sort = (tableName, first, second) => {
        const sortColumn = tableName === "Selecionados" ? this.state.sortColumnSelected : this.state.sortColumnAvailable;
        const sortOrder = tableName === "Selecionados" ? this.state.sortOrderSelected : this.state.sortOrderAvailable;

        var a = (first)[sortColumn];
        var b = (second)[sortColumn];

        if (sortColumn === 'isActive') {
            if (sortOrder === 'ascending') {
                return (a === b) ? 0 : (a ? -1 : 1);
            }

            return (a === b) ? 0 : (a ? 1 : -1);
        }

        if (a === undefined && b === undefined) {
            return 0;
        } else if (a === undefined) {
            if (sortOrder === "ascending") {
                return 1;
            } else {
                return -1;
            }
        } else if (b === undefined) {
            if (sortOrder === "ascending") {
                return -1;
            } else {
                return 1;
            }
        }

        if (sortOrder === "ascending") {
            return typeof a === 'number' ? a - b : a.localeCompare(b);
        }

        return typeof b === 'number' ? b - a : b.localeCompare(a);
    }


    render() {
        const { selectedStops, stopsToRender } = this.state;

        return (
            <Modal show={this.props.show} dialogClassName="modal-90w-75h">
                <Modal.Header>
                    <Modal.Title>Gerir Paragens Associadas</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.renderStopsTable(stopsToRender, selectedStops)}
                    <Row className="btns-small-screens-inside-modal padding-left-15">
                        <ButtonToolbar>
                            <Button onClick={() => this.onSaveStopValue(selectedStops)}>GUARDAR</Button>
                            <Button onClick={() => this.onHide()}>CANCELAR</Button>
                            <Button onClick={() => this.onCalculateCoordinates()} disabled={selectedStops.length === 0}>CALCULAR COORDENADAS</Button>
                        </ButtonToolbar>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }

    renderStopsTable(stops, selectedStops) {
        const { mapPoint } = this.props;
        const { isLoadingStops, isLoadingSelectedStops, distance } = this.state;

        const availableStops = stops.filter(s => !selectedStops.some(sel => sel.id === s.id));
        const lat = parseFloat(mapPoint.latitude);
        const lng = parseFloat(mapPoint.longitude);

        return (
            <div className="stops-table-wrapper">
                {mapPoint && (
                    <div className="point-info">
                        <h4 style={{ marginBottom: '10px' }}>{mapPoint.name || "Ponto sem nome"}</h4>
                        <p style={{ margin: 0, color: "#555" }}>
                            Coordenadas Atuais: <strong>{isNaN(lat) ? "N/A" : lat.toFixed(6)}</strong>, <strong>{isNaN(lng) ? "N/A" : lng.toFixed(6)}</strong>
                        </p>
                    </div>
                )}

                <div className="table-small-screens">
                    {this.renderTableSection("Disponíveis", availableStops, false, isLoadingStops)}
                    {this.renderTableSection("Selecionados", selectedStops, true, isLoadingSelectedStops)}
                </div>

                <div className="distance-form">
                    <FormGroup controlId="formDistance">
                        <ControlLabel>Distância (metros)</ControlLabel>
                        <div className="distance-input-group">
                            <FormControl
                                type="number"
                                min="0"
                                value={distance}
                                placeholder="Introduza a distância"
                                onChange={(e) => this.handleDistanceChange(e)}
                                disabled={isNaN(lat) || isNaN(lng)}
                            />
                            <Button onClick={() => this.selectNearbyStops()} disabled={isNaN(lat) || isNaN(lng)}>
                                Selecionar Paragens Vizinhas
                            </Button>
                        </div>
                    </FormGroup>
                </div>
            </div>
        );
    }

    renderTableSection(title, stops, isRemovable, isLoading) {
        return (
            <div className="table-section">
                <h5 className="table-header">{title}</h5>
                <div className="scrollable-table">
                    {isLoading ? <LoadingSpinner className="loading" /> : (
                        <Table responsive striped hover condensed>
                            <thead>{this.renderTableHeader(title)}</thead>
                            <tbody>{this.renderStopsTableBody(stops, isRemovable, title)}</tbody>
                        </Table>
                    )}
                </div>
            </div>
        );
    }

    renderTableHeader(title) {
        const sortColumn = title === 'Selecionados'
            ? this.state.sortColumnSelected
            : this.state.sortColumnAvailable;

        const sortOrder = title === 'Selecionados'
            ? this.state.sortOrderSelected
            : this.state.sortOrderAvailable;

        return (
            <tr>
                <th onClick={() => this.onChangeSort(title, 'code')}>{"Código"} {sortColumn === "code" ? <SortIndicator order={sortOrder} /> : <SortIndicator order="none" />}</th>
                <ColumnResize className="columnResizer" />
                <th onClick={() => this.onChangeSort(title, 'name')}>{"Nome"} {sortColumn === "name" ? <SortIndicator order={sortOrder} /> : <SortIndicator order="none" />}</th>
                <ColumnResize className="columnResizer" />
                <th onClick={() => this.onChangeSort(title, 'latitude')}>{"Latitude"} {sortColumn === "latitude" ? <SortIndicator order={sortOrder} /> : <SortIndicator order="none" />}</th>
                <ColumnResize className="columnResizer" />
                <th onClick={() => this.onChangeSort(title, 'longitude')}>{"Longitude"} {sortColumn === "longitude" ? <SortIndicator order={sortOrder} /> : <SortIndicator order="none" />}</th>
                <ColumnResize className="columnResizer" />
                <th onClick={() => this.onChangeSort(title, 'isActive')}>{"Ativa"} {sortColumn === "isActive" ? <SortIndicator order={sortOrder} /> : <SortIndicator order="none" />}</th>
                <ColumnResize className="columnResizer" />
                <th onClick={() => this.onChangeSort(title, 'distance')}>{"Distancia"} {sortColumn === "distance" ? <SortIndicator order={sortOrder} /> : <SortIndicator order="none" />}</th>
                <ColumnResize className="columnResizer" />
                <th>Ação</th>
            </tr>
        );
    }

    renderStopsTableBody(stops, isRemovable, title) {
        return stops.sort((a,b) => this.sort(title, a, b)).map(stop => (
            <tr key={`stop-${isRemovable ? "sel" : "opt"}-${stop.id}`}>
                <td>{stop.code}</td>
                <td className="column_resizer_body" />
                <td>{stop.name}</td>
                <td className="column_resizer_body" />
                <td>{stop.latitude}</td>
                <td className="column_resizer_body" />
                <td>{stop.longitude}</td>
                <td className="column_resizer_body" />
                <td>{stop.isActive ? "Sim" : "Não"}</td>
                <td className="column_resizer_body" />
                <td className="column_resizer_body" />
                <td className="map-point-form-table-col-distance">{typeof stop.distance === 'number' ? stop.distance : "Não Definido"}</td>
                <td className="column_resizer_body" />
                <td>
                    <Button
                        bsStyle={isRemovable ? "danger" : "success"}
                        bsSize="xs"
                        title={isRemovable ? "Remover esta paragem" : "Selecionar esta paragem"}
                        onClick={() =>
                            isRemovable
                                ? this.onRemoveSelectedStopValue(stop.id)
                                : this.onChangeStopValue(stop)
                        }
                    >
                        <i className={`glyphicon glyphicon-${isRemovable ? "remove" : "ok"}`} />
                    </Button>
                </td>
            </tr>
        ));
    }
}
